import { Timestamp } from '@dixa/lib-shared-habla';

import { ConversationsTableSortableField } from 'components/conversation/conversationTable';

import { useConversationRow } from '../../../utils/useConversationRow';

type ConversationsTableTimestampProps = {
  timestampKey: ConversationsTableSortableField;
};

/** Represents the content of a timestamp cell in the conversations table. */
export const ConversationsTableTimestamp = ({
  timestampKey,
}: ConversationsTableTimestampProps): JSX.Element | null => {
  const { conversation } = useConversationRow();
  const timestamp = conversation[timestampKey];

  return timestamp ? <Timestamp time={timestamp} relative /> : null;
};
